import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import ptBr from './locales/pt-BR';

const resources = {
  'pt-BR': ptBr,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (!value) {
          return value;
        }
        switch (format) {
          case 'lowercase':
            return (value as string).toLowerCase();
          default:
            return value;
        }
      },
    },
  });

export default i18n;
